export enum METHODS {
    GET_PRINTER_LIST = "printix.api.get_printer_list",
    GET_TODAY_INVOICE_LIST = "printix.api.get_today_invoice_list",
    GET_PRINTING_SESSION_LIST = "printix.api.get_printix_session_list",
    GENERATE_PDF_BUNDLE = "printix.api.generate_pdf_bundle",
    GET_TODAY_PRINTED_INVOICE_LIST = "printix.api.get_today_printed_invoice_list"
}